import React from "react";
import ReactDOM from "react-dom/client";
import { LicenseInfo } from "@mui/x-license-pro";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import store, { persistor } from "./store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import "react-datepicker/dist/react-datepicker.css";
import "animate.css";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import "react-quill/dist/quill.snow.css";
import { CircularProgress } from "@mui/material";
// import HttpsRedirect from "react-https-redirect";

// The app has both MUI X v6 (@mui/x-license-pro, used by DataGridPro 6) and v8
// (@mui/x-license, pulled by another MUI X package) installed. Set the same key
// on BOTH so no grid watermarks — mirroring the working sales.figk-12.com app.
// The v8 package is loaded defensively: if it ever fails to load, it must NOT
// take down the whole app (index.js runs before React renders).
const MUI_X_KEY = process.env.REACT_APP_MUI_X_LICENSE_KEY || "";
LicenseInfo.setLicenseKey(MUI_X_KEY);
try {
  // eslint-disable-next-line global-require
  const { LicenseInfo: LicenseInfoX } = require("@mui/x-license");
  if (LicenseInfoX && typeof LicenseInfoX.setLicenseKey === "function") {
    LicenseInfoX.setLicenseKey(MUI_X_KEY);
  }
} catch (e) {
  // v8 license package unavailable — DataGridPro v6 is still licensed above.
  console.warn("MUI x-license (v8) key not set:", e?.message);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <Provider store={store}>
      {/* <HttpsRedirect> */}
        <PersistGate loading={<div className="loader">
          <CircularProgress sx={{ color: "#86c65a" }} />
        </div>} persistor={persistor}>
          <App />
        </PersistGate>
      {/* </HttpsRedirect> */}
    </Provider>
  </>
);

// "start": "react-scripts start",(packege.json)
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
